var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement_box"},[_c('div',{staticClass:"agreement_content_box"},[_c('div',{staticClass:"ft_logo"}),(_vm.backFlag)?_c('div',{staticClass:"close passIconfont icon-ftshanchu",on:{"click":_vm.close}}):_vm._e(),_c('div',{staticClass:"agreement_content"},[_c('usercontent',{on:{"controFlag":_vm.controFlag}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }